import api from '@/utils/axios';
import { invalidateOrgReferenceOptions } from '@/api/orgReferenceApi';

const invalidateCaches = () => {
  invalidateOrgReferenceOptions();
};

export const fetchGradesList = async ({ includeInactive = false } = {}) => {
  const response = await api.post('grades/get', {
    include_inactive: includeInactive ? 1 : 0,
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to fetch grades');
  }
  const data = response.data.data || {};
  return Array.isArray(data.grades) ? data.grades : [];
};

export const createGrade = async (payload) => {
  const response = await api.post('grades/manage', {
    action: 'create',
    ...payload,
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to create grade');
  }
  invalidateCaches();
  return response.data.data;
};

export const updateGrade = async (payload) => {
  const response = await api.post('grades/manage', {
    action: 'update',
    ...payload,
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to update grade');
  }
  invalidateCaches();
  return response.data.data;
};

export const updateGradeStatus = async ({ grade_id, is_active }) => {
  const response = await api.post('grades/manage', {
    action: 'update',
    grade_id,
    is_active: is_active ? 1 : 0,
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to update grade status');
  }
  invalidateCaches();
  return response.data.data;
};

export const deleteGrade = async ({ grade_id }) => {
  const response = await api.post('grades/manage', {
    action: 'delete',
    grade_id,
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to delete grade');
  }
  invalidateCaches();
  return response.data.data;
};
